import { T } from "@/i18n";
import { Label } from "./ui/label";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export function Field({
  label,
  id,
  children,
  errors,
  orientation = "vertical",
}: {
  orientation?: "horizontal" | "vertical";
  label: string | ReactNode | null;
  id: string;
  children?: React.ReactNode;
  errors?: string[] | undefined;
}) {
  return (
    <div className="flex flex-col items-start gap-2">
      <div
        className={cn(
          "flex w-full gap-2",
          orientation === "vertical"
            ? "flex-col items-start"
            : "items-center justify-start",
        )}
      >
        {label !== null ? (
          <Label htmlFor={id} className="text-right">
            {typeof label === "string" ? <T tKey={label} /> : label}
          </Label>
        ) : (
          <></>
        )}
        {children}
      </div>
      <FormErrors errors={errors} />
    </div>
  );
}

export function FormErrors({ errors }: { errors: string[] | undefined }) {
  return (
    !!errors?.length && (
      <div className="flex w-full flex-col items-start gap-1">
        {errors.map((e) => (
          <Label key={e} className="text-right text-xs text-destructive">
            <T tKey={e} />
          </Label>
        ))}
      </div>
    )
  );
}
